import { render, staticRenderFns } from "./AdminCommonInfo.vue?vue&type=template&id=31e17a20&scoped=true&"
import script from "./AdminCommonInfo.vue?vue&type=script&lang=js&"
export * from "./AdminCommonInfo.vue?vue&type=script&lang=js&"
import style0 from "./AdminCommonInfo.vue?vue&type=style&index=0&id=31e17a20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e17a20",
  null
  
)

export default component.exports